import React from "react";

const InstaIframe = () => {
  return (
    <iframe
      title="insta"
      src="https://instagram.demobw.live/showcase/"
      frameborder="0"
      width="100%"
      className="insta-iframe"
    ></iframe>
  );
};

export default InstaIframe;
